import styled from '@emotion/styled';

import { spacing, typography, colors } from '../tokens';

/**
 * Divisor tracejado entre itens (Figma: dashed, com inset à direita — "não vai
 * até o fim"). TODO(ds): unificar num token de divisor (RouteStatusNote #262626,
 * SelectableCard #D9D9D9 — divergência a convergir, bloqueada por validação UX).
 */
const DIVIDER_COLOR = '#D9D9D9';

export const RowRoot = styled('div', {
  shouldForwardProp: (p) => !p.toString().startsWith('$'),
})<{ $divider: boolean }>`
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: ${spacing.md};
  padding: ${spacing.md} 0;

  /* Divisor tracejado curto (não vai até o fim). O ::after é sempre declarado;
     só o display é alternado — interpolação de valor único, robusta no SWC. */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 35%;
    bottom: 0;
    border-bottom: 1px dashed ${DIVIDER_COLOR};
    display: ${({ $divider }) => ($divider ? 'block' : 'none')};
  }
`;

export const IconSlot = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: #3d3d3d;
  line-height: 0;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const TextBlock = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Label = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.extraBold};
  line-height: 1.35;
  color: #3d3d3d;
`;

export const Value = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.regular};
  line-height: 1.35;
  color: ${colors.text};
`;
